import WalletPage from "./WalletPage";

export default WalletPage;
